<template>
  <b-row>
    <b-col md="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h5 class="card-title text-primary">
            <strong>SHIPMENT REAL</strong>
          </h5>
        </template>
        <template v-slot:body>
          <!-- FILTER START -->
          <div class="d-flex justify-content-between mb-3">
            <div class="d-flex">
              <b-form class="d-flex" @submit.prevent="onFilter">
                <b-form-input
                  placeholder="search project..."
                  style="width: 220px"
                  v-model="params.keyword"
                  class="mr-2"
                ></b-form-input>
              </b-form>
              <b-button
                variant="outline-primary"
                class="d-flex align-items-center"
                @click="toggleModalFilter"
              >
                <i class="fas fa-sliders"></i>
                <p class="text-truncate m-0">Filter Data</p>
              </b-button>
              <b-button
                variant="outline-primary"
                class="d-flex align-items-center ml-2"
                v-b-tooltip.top="'Refresh Data'"
                @click="onFilter"
              >
                <i class="fas fa-sync-alt"></i>
              </b-button>
            </div>
            <div class="d-flex">
              <b-dropdown
                v-b-tooltip.top="'Export Data'"
                variant="link iq-bg-primary"
                toggle-class="text-decoration-none"
                no-caret
                class="mr-1"
              >
                <template v-slot:button-content>
                  <span
                    class="dropdown-toggle p-0"
                    id="dropdownMenuButton5"
                    data-toggle="dropdown"
                  >
                    <i class="fa fa-download mr-1"></i>
                    Export
                  </span>
                </template>
                <b-dropdown-item
                  href="#"
                  variant="dark"
                  @click="$bvModal.show('report-ports')"
                >
                  <i class="fa fa-file-excel mr-2"></i>
                  Export Report All Ports
                </b-dropdown-item>
              </b-dropdown>
              <!-- <b-button
                @click="refreshDataTable"
                variant="primary"
                class="float-right mr-1"
              >
                <i class="fa fa-refresh"></i>
                &nbsp; Refresh Data
              </b-button> -->
              <b-button
                @click="slideRunningShipment = true"
                variant="primary"
                class="float-right mr-1"
              >
                View Running Operation Data
              </b-button>
            </div>
          </div>

          <b-modal
            v-model="modal.filter"
            centered
            title="Filter Data"
            ok-title="Filter"
            @ok="onFilter"
          >
            <b-row class="">
              <b-col md="12">
                <b-form-group
                  label="Period"
                  label-for="Period"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  class="mb-3"
                >
                  <date-picker
                    v-model="dateRange"
                    type="date"
                    range
                    placeholder="Select date range"
                    :style="{ width: '100%' }"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Cargo Type"
                  label-for="cargo"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  class="mb-3"
                >
                  <b-form-select
                    plain
                    :options="optionsCargoType"
                    v-model="params.cargo_type_id"
                  >
                    <b-form-select-option :value="null">
                      All
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Stage Status"
                  label-for="stage_id"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  class="mb-3"
                >
                  <b-form-select
                    plain
                    v-model="params.stage_id"
                    class="mb-2"
                    :options="optionsStage"
                  >
                    <b-form-select-option :value="null">
                      All
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Ownership"
                  label-for="fleet_ownership"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  class="mb-3"
                >
                  <b-form-select
                    plain
                    v-model="params.fleet_ownership"
                    class="mb-2"
                  >
                    <b-form-select-option value="">All</b-form-select-option>
                    <b-form-select-option value="own-ship">
                      Own Ship
                    </b-form-select-option>
                    <b-form-select-option value="chartered">
                      Chartered
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="params.fleet_ownership">
                <b-form-group
                  label="Vehicle"
                  label-for="vehicle_id"
                  label-cols-sm="4"
                  label-cols-lg="3"
                >
                  <v-select
                    label="text"
                    name="vehicle_id"
                    v-model="params.vehicle_id"
                    :options="optionsFleets"
                    :reduce="(optionsFleets) => optionsFleets.value"
                    placeholder="Select Fleet"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-modal>
          <!-- FILTER END -->

          <!-- END Show Value Filter -->
          <b-row>
            <b-col md="12" v-if="!loading">
              <div class="d-flex overflow-auto" style="max-height: 500px">
                <table class="table table-xs">
                  <thead class="thead-light">
                    <tr class="sticky-header">
                      <th class="text-truncate" style="width: 200x">Shipper</th>
                      <th class="text-truncate">Cargo TYPE</th>
                      <th
                        class="bg-primary-custom text-truncate"
                        style="width: 200px"
                      >
                        Shipment Plan
                      </th>
                      <th
                        class="bg-primary-custom text-truncate"
                        style="width: 200px"
                      >
                        Volume Plan
                      </th>
                      <th
                        class="bg-warning-custom text-truncate"
                        style="width: 200px"
                      >
                        Shipment Real
                      </th>
                      <th
                        class="bg-warning-custom text-truncate"
                        style="width: 200px"
                      >
                        Volume Real
                      </th>
                      <th class="text-center">Stage</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="list.data.length > 0">
                    <tr v-for="(state, index) in list.data" :key="index">
                      <td class="text-truncate text-center">
                        <div
                          class="d-flex align-items-center"
                          style="cursor: pointer"
                          @click="openNewWindow(state?.customer?.id)"
                        >
                          <h6 class="ml-2 text-primary">
                            <strong>
                              {{ state?.company?.company ?? '-' }}
                            </strong>
                          </h6>
                        </div>
                      </td>
                      <td
                        class="text-truncate text-primary"
                        style="cursor: pointer"
                        @click="openSlideFormAddPlan('PREVIEW', state?.id)"
                      >
                        {{ state?.cargo_type?.name }}
                      </td>
                      <td
                        class="text-truncate"
                        style="cursor: pointer"
                        @click="openSlideFormAddPlan('PREVIEW', state?.id)"
                      >
                        {{ state?.shipment }} SHIPMENT
                      </td>
                      <td
                        class="text-truncate"
                        style="cursor: pointer"
                        @click="openSlideFormAddPlan('PREVIEW', state?.id)"
                      >
                        {{
                          state?.volume ? state?.volume?.toLocaleString() : '0'
                        }}
                        {{
                          state?.cargo_type?.unit?.child?.find(
                            (el) => el.name === state.unit
                          )?.alias
                        }}
                      </td>
                      <td class="text-truncate">
                        {{ state?.shipment_real }} SHIPMENT
                      </td>
                      <td class="text-truncate">
                        {{
                          state?.volume_real
                            ? state?.volume_real?.toLocaleString()
                            : '0'
                        }}
                        {{
                          state?.cargo_type?.unit?.child?.find(
                            (el) => el.name === state.unit
                          )?.alias
                        }}
                      </td>
                      <td class="bg-white text-black text-center">
                        <b-button
                          :id="`stage-popover-${index}-${state?.id}`"
                          variant="primary"
                          size="sm"
                          class="text-nowrap"
                        >
                          {{ state?.project_stage?.title }}
                          <i class="fas fa-chevron-down ml-2"></i>
                        </b-button>
                        <b-popover
                          :target="`stage-popover-${index}-${state?.id}`"
                          triggers="focus"
                          placement="left"
                          custom-class="p-0 border-0 shadow-sm"
                        >
                          <div class="list-group list-group-flush text-left">
                            <button
                              v-for="(obj, objIndex) in listProjectStage"
                              :key="objIndex"
                              class="list-group-item list-group-item-action"
                              :class="{
                                active:
                                  state?.detail_project_stage_id === obj.id,
                              }"
                              @click="
                                onChangeStatusStage(index, state?.id, obj.id)
                              "
                            >
                              {{ obj?.title }}
                            </button>
                          </div>
                        </b-popover>
                      </td>
                      <td class="bg-white text-black text-center">
                        <b-button
                          :id="`action-popover-${index}-${state?.id}`"
                          variant="outline-primary"
                          size="sm"
                        >
                          Action
                        </b-button>
                        <b-popover
                          :target="`action-popover-${index}-${state?.id}`"
                          triggers="focus"
                          placement="left"
                          custom-class="p-0 border-0 shadow-sm"
                        >
                          <div class="list-group list-group-flush text-left">
                            <button
                              class="list-group-item list-group-item-action"
                              @click="
                                openSlideFormAddPlan('PREVIEW', state?.id)
                              "
                            >
                              <i class="fa fa-eye mr-2"></i>
                              Detail
                            </button>
                            <button
                              class="list-group-item list-group-item-action"
                              @click="
                                openSlideFormRealShipment('ADD', state?.id)
                              "
                            >
                              <i class="fa fa-plus mr-2"></i>
                              Add Real Shipment
                            </button>
                          </div>
                        </b-popover>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center align-middle">
                        <h6 class="text-muted">
                          <strong>No Data Found.</strong>
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-3" v-if="list.data.length > 0">
                <b-pagination
                  v-model="page"
                  :total-rows="list.meta.totalItem"
                  @change="getListRunningShipmentTable"
                  :per-page="list.meta.perPage"
                  first-number
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
            <b-col md="12" v-else>
              <div class="alert alert-info">Loading...</div>
            </b-col>
          </b-row>
        </template>
      </iq-card>
    </b-col>

    <b-col md="12">
      <!-- SLIDE - FORM ADD PLAN -->
      <b-sidebar
        v-model="slideAddRakor"
        id="add_rakor"
        :title="
          ['PREVIEW', 'EDIT'].includes(action) ? 'DETAIL PLAN' : `ADD PLAN`
        "
        width="100%"
        backdrop-variant="dark"
        bg-variant="white"
        right
        backdrop
        shadow
      >
        <template #default="{ hide }">
          <FormAddPlanNew
            v-if="slideAddRakor"
            :optionsCompanies="optionsCompanies"
            :optionsFleets="optionsFleets"
            :editId="editId"
            :isDetail="action === 'PREVIEW'"
            @refresh-data="getListRunningShipmentTable"
          />
        </template>
      </b-sidebar>
      <!-- SLIDE - FORM ADD PLAN END -->
    </b-col>

    <!-- SLIDE - FORM REAL SHIPMENT -->
    <b-col md="12">
      <b-sidebar
        v-model="slideFormRealShipment"
        id="slideFormRealShipment"
        :title="`Create Real Shipment`"
        width="90%"
        backdrop-variant="dark"
        bg-variant="white"
        right
        backdrop
        shadow
      >
        <template #default="{ hide }">
          <SlideFormRealShipment
            :closeSlideFormRealShipment="closeSlideFormRealShipment"
            :refreshData="() => {}"
            :optionsFleets="optionsFleets"
            :projectId="idRealShipment"
            :action="actionRealShipment"
          />
        </template>
      </b-sidebar>
    </b-col>
    <!-- SLIDE - FORM REAL SHIPMENT END -->

    <!-- SLIDE - RUNNING SHIPMENT -->

    <b-col md="12">
      <b-sidebar
        v-model="slideRunningShipment"
        id="slideRunningShipment"
        :title="`Operational Data Running Shipment`"
        width="100%"
        backdrop-variant="dark"
        bg-variant="white"
        right
        backdrop
        shadow
      >
        <SlideRunningShipment />
      </b-sidebar>
    </b-col>

    <!-- FORM BLACK LIST  -->
    <b-modal
      id="report-ports"
      size="md"
      title="Export Report All Ports"
      cancel-title="Close"
      hide-footer
    >
      <template #default="{ hide }">
        <b-row>
          <b-col md="12">
            <b-form-group label="*List Ports" label-for="vehicle_type">
              <v-multiselect
                :options="positionList"
                placeholder="Select..."
                track-by="value"
                label="text"
                v-model="exportForm.portIds"
                :multiple="true"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </v-multiselect>
            </b-form-group>
            <b-form-group
              label="*Start Date"
              label-for="startDate"
              class="text-truncate"
            >
              <date-picker
                class="custom-date-picker w-100"
                v-model="exportForm.startDate"
                value-type="DD-MM-YYYY"
                type="date"
                placeholder="Select date"
                format="DD-MM-YYYY"
              ></date-picker>
            </b-form-group>
            <b-form-group
              label="*End Date"
              label-for="startDate"
              class="text-truncate"
            >
              <date-picker
                class="custom-date-picker w-100"
                v-model="exportForm.endDate"
                value-type="DD-MM-YYYY"
                type="date"
                placeholder="Select date"
                format="DD-MM-YYYY"
              ></date-picker>
            </b-form-group>

            <div class="d-flex w-100 align-items-center justify-content-end">
              <b-button
                variant="secondary"
                size="sm"
                class="mr-2"
                @click="$bvModal.hide('report-ports')"
              >
                Cancel
              </b-button>
              <b-button
                variant="primary"
                @click="onExportPort()"
                :disabled="exporting"
              >
                <span
                  v-if="exporting"
                  class="spinner-border spinner-border-sm"
                />
                <div v-else class="d-flex gap-2 align-items-center">
                  <span>Export</span>
                  <i class="fa fa-upload ml-2"></i>
                </div>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import {
  projectsActions,
  companiesActions,
  fleetsActions,
  busdevActions,
  crewingActions,
  portsActions,
  voyagesActions,
} from '@src/Utils/helper'
import SlideFormRealShipment from './SlideFormRealShipment.vue'
import SlideDetailRealisasi from './SlideDetailRealisasi.vue'
import { saveAs } from 'file-saver'
import FormAddPlan from './FormAddPlan.vue'
import FormAddPlanNew from './FormAddPlanNew.vue'
import SlideRunningShipment from './SlideRunningShipment.vue'

export default {
  name: 'TabRealisasi',
  data() {
    return {
      action: '',
      idRealShipment: null,
      actionRealShipment: '',

      isEdit: false,
      editId: null,
      pfaId: null,

      dateRange: [],
      positionList: [],
      slideFormRealShipment: false,
      slideDetailRealisasi: false,
      slideRunningShipment: false,

      exporting: false,
      saving: false,
      loading: false,
      detail_project_loading: false,
      fleet_loading: false,

      slideAddPreviewInspectionChecklist: false,
      isPreviewInspectionChecklist: false,
      isAddInspectionChecklist: false,
      inspectionChecklistData: null,
      slideAddRakor: null,

      projectOptions: [],
      optionsCompanies: [],
      optionsCustomerClass: [],
      optionsTerms: [],
      optionsFleets: [],
      optionsContractType: [],
      optionsCargoType: [],
      optionsStage: [],
      listProjectStage: [],

      ownership: [
        {
          name: 'ownship',
          label: 'OWN SHIP',
          value: 'own-ship',
          disabled: false,
        },
        {
          name: 'chartered',
          label: 'CHARTERED',
          value: 'chartered',
          disabled: false,
        },
      ],

      dateRange: [
        new Date(moment().startOf('year')),
        new Date(moment().endOf('year')),
      ],
      page: 1,
      params: {
        periode_start: null,
        periode_end: null,
        cargo_type_id: null,
        fleet_ownership: '',
        keyword: '',
        stage_id: null,
      },

      list: {
        data: [],
        meta: null,
      },

      userProfileId: JSON.parse(localStorage.getItem('profile')).id,
      userProfileName: JSON.parse(localStorage.getItem('profile')).userDetail
        .name,
      modal: {
        filter: false,
      },

      exportForm: {
        portIds: [],
        startDate: '',
        endDate: '',
      },
    }
  },
  components: {
    FormAddPlan,
    SlideFormRealShipment,
    SlideDetailRealisasi,
    SlideRunningShipment,
    FormAddPlanNew,
  },
  async mounted() {
    await this.getListRunningShipmentTable()
    await this.fetchPerusahaan()
    await this.fetchFleets()
    await this.getCargoType()
    await this.getListProjectStage()
    await this.getPortList()
  },
  computed: {
    addPermission() {
      let hasAccess = JSON.parse(localStorage.getItem('profile'))
        .menu.find((obj) => obj.menu === 'Apps')
        .child.find((obj) => obj.menu === 'Business Development')
        .child.find((obj) => obj.menu === 'Business Development Record').add

      return hasAccess
    },
    updatePermission() {
      let hasAccess = JSON.parse(localStorage.getItem('profile'))
        .menu.find((obj) => obj.menu === 'Apps')
        .child.find((obj) => obj.menu === 'Business Development')
        .child.find((obj) => obj.menu === 'Business Development Record').update

      return hasAccess
    },
    deletePermission() {
      let hasAccess = JSON.parse(localStorage.getItem('profile'))
        .menu.find((obj) => obj.menu === 'Apps')
        .child.find((obj) => obj.menu === 'Business Development')
        .child.find((obj) => obj.menu === 'Business Development Record').delete

      return hasAccess
    },
  },
  methods: {
    ...projectsActions,
    ...fleetsActions,
    ...companiesActions,
    ...busdevActions,
    ...crewingActions,
    ...portsActions,
    ...voyagesActions,
    toggleModalFilter() {
      this.modal.filter = !this.modal.filter
    },

    openNewWindow(id) {
      const queryParamValue = 'yourValue'
      const url = this.$router.resolve({
        path: '/busdev/customer',
        query: { id },
      }).href
      window.open(url, '_blank') // Opens in a new tab/window
    },

    showVehicleName(value) {
      let vehicle = this.optionsFleets.find((obj) => obj.value == value)

      return vehicle?.text ?? '-'
    },

    openSlideFormRealShipment(value, id) {
      this.idRealShipment = null
      this.actionRealShipment = value
      this.slideFormRealShipment = !this.slideFormRealShipment

      if (id) this.idRealShipment = id
    },
    closeSlideFormRealShipment() {
      this.idRealShipment = null
      this.actionRealShipment = ''
      this.slideFormRealShipment = false
    },

    closeSlideDetailRealisasi() {
      this.action = ''
      this.slideDetailRealisasi = false
    },
    openSlideDetailRealisasi(value, id) {
      this.id = null
      this.slideDetailRealisasi = !this.slideDetailRealisasi

      if (id) this.id = id
    },

    updateAction(newAction) {
      this.action = newAction
    },

    openInspectionChecklistSlide(
      isPreview,
      isAdd,
      data,
      vehicle_id,
      vehicle_type_name,
      form_id
    ) {
      this.inspectionChecklistData = null

      this.slideAddPreviewInspectionChecklist = true
      this.isPreviewInspectionChecklist = isPreview
      this.isAddInspectionChecklist = isAdd
      this.inspectionChecklistData = data
      this.inspectionChecklistData.vehicle_id = vehicle_id
      this.inspectionChecklistData.vehicle_type_name = vehicle_type_name
      this.inspectionChecklistData.form_id = form_id
    },

    openSlideFormAddPlan(value, id) {
      this.editId = null
      this.action = value
      this.slideAddRakor = !this.slideAddRakor

      if (id) this.editId = id
    },

    refreshDataTable() {
      this.slideAddRakor = false
      this.editId = null
      this.action = ''

      this.getListRunningShipmentTable()
    },
    async getPortList() {
      let params = {
        active: true,
        search: '',
        page: 1,
        perPage: 999999999,
      }
      const res = await this.getPorts(params)
      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          res.data.data.forEach((val) => {
            this.positionList.push({ value: val.id, text: val.portName })
          })
        }
      } else {
        this.$swal(`Oops!`, res.data.data, 'error')
      }
    },

    async fetchPerusahaan() {
      let res = await this.fetchCompanies()
      if (res.status) {
        if (res.data && res.data.length > 0) {
          res.data.map((state) => {
            this.optionsCompanies.push({
              value: state.id,
              text: state.company,
            })
          })
        }
      }
    },
    async fetchFleets(ownership) {
      // this.fleet_loading = true
      let params = this.$options.filters.cleanObject({
        page: 1,
        perPage: 9999,
        showAll: true,
        active: true,
        ownership,
      })

      if (!params.ownership) delete params.ownership

      let res = await this.getFleets(params)

      if (res.status) {
        if (res.data && res.data.length > 0) {
          this.optionsFleets = res.data.map((val) => ({
            text: val.name,
            value: val.id,
          }))
        }
      }

      // this.fleet_loading = false
    },
    async getCargoType() {
      let res = await this.fetchCargoType()
      if (res.data.status === true && res.data.data.length > 0) {
        res.data.data.map((state) => {
          this.optionsCargoType.push({
            ...state,
            value: state.id,
            text: state.name,
          })
        })
      }
    },
    async getListProjectStage() {
      this.listProjectStage = []
      let res = await this.fetchDetailProjectStage()
      if (res?.status == 'success' || res.data.status == true) {
        if (res.data.data && res.data.data.length > 0) {
          this.optionsStage = res.data.data.map((val) => {
            return {
              text: val.title,
              value: val.id,
            }
          })

          this.optionsStage = this.optionsStage.filter((obj) =>
            ['Process', 'Done'].includes(obj.text)
          )
          this.listProjectStage = res.data.data
        }
      }
    },
    async onChangeStatusStage(index, id, project_stage_id) {
      let payload = {
        id,
        project_stage_id,
      }

      const res = await this.changeStatusStage({ data: payload })

      if (res.data.status === true) {
        console.log('Status Stage Changed')
        this.getListRunningShipmentTable()
      }
    },

    async getListRunningShipmentTable(page = 1) {
      this.loading = true
      this.list = {
        data: [],
        meta: null,
      }
      let params = {
        page: page,
        perPage: 50,
        ...this.params,
        periode_start: this.dateRange?.[0]
          ? moment(this.dateRange?.[0]).format('YYYY-MM-DD')
          : null,
        periode_end: this.dateRange?.[1]
          ? moment(this.dateRange?.[1]).format('YYYY-MM-DD')
          : null,
      }

      if (!params.keyword) delete params.keyword
      if (!params.cargo_type_id) delete params.cargo_type_id
      if (!params.fleet_ownership) delete params.fleet_ownership
      if (!params.periode_start) delete params.periode_start
      if (!params.periode_end) delete params.periode_end

      let res = await this.fetchRunningShipmentTable(params)

      if (res.data.status === true && res.data.data?.data.length > 0) {
        this.list.data = res.data.data?.data
        this.list.meta = res.data.data?.meta
      }
      this.loading = false
    },
    // FILTER
    async onFilter() {
      await this.getListRunningShipmentTable()
    },

    // FILTER
    async onExportPort() {
      if (
        !this.exportForm.startDate ||
        !this.exportForm.endDate ||
        !this.exportForm.portIds.length <= 0
      ) {
        return this.$swal(
          'Form Required.',
          'All Form required, fill it first.',
          'warning'
        )
      }

      this.exporting = true
      let params = {
        ...this.exportForm,
        portIds: this.exportForm?.portIds?.map((val) => val.value)?.toString(),
      }

      await this.exportVoyagePerPorts({ params })
      saveAs(res.data, 'Ports.xlsx')
      this.exporting = false
    },
  },
}
</script>

<style scoped>
.sticky-header {
  position: sticky;
  top: 0;
  /* background-color: white; */
  z-index: 1;
}
.bg-primary-custom {
  background-color: #334697 !important;
  color: #ffffff !important;
}
.bg-warning-custom {
  background-color: #ffa500 !important;
  color: #ffffff !important;
}
</style>
